import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  ApiUrl,
  ApiKey,
  WebUrl,
} from "../../util/Constant";
import ApiEngine from '../../util/ApiEngine';
import { useHistory } from "react-router-dom";

const SpinWheelButton = () => {
  const _history = useHistory();
  const { isLoggedIn } = useSelector((state) => state.authState);
  const [freeSpinCount, setFreeSpinCount] = useState(0);

  useEffect(() => {
    if (isLoggedIn) {
      checkMemberHasFreeSpin();
    } else {
      setFreeSpinCount(0);
    }
  }, [isLoggedIn]);

  const checkMemberHasFreeSpin = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_CHECK_FREE_SPIN_COUNT);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      if (data != null && data > 0) {
        setFreeSpinCount(data);
      }
      else {
        setFreeSpinCount(0);
      }
    }
    else {
      setFreeSpinCount(0);
    }
  }

  const miniMemoComponent = useMemo(() => {
    return (
      <div className="spin-container-open" onClick={() => _history.push(WebUrl._URL_SPIN_WHEEL)}>
        {freeSpinCount > 0 && <span className="notification-dot">{freeSpinCount}</span>}
      </div>
    );
  }, [freeSpinCount])

  return (
    <>
      {miniMemoComponent}
    </>
  )
}

export default SpinWheelButton;
